




















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component

export default class GetMore extends Vue {
  page_type: any = ''
  title: any = ''
  loading: boolean = false
  list: any = [] // 专辑列表
  if_more: boolean = true // 是否有下一页
  limit: any = 10
  async mounted() {
    await this.subTabList()
  }
  async infiniteLoad() {
    if (!this.if_more) return
    await this.subTabList()
  }
  async subTabList() {
    if (this.loading) return
    let { data } = await this.$axios.get(`/api/mobile/audios/resource2/morePage`, {
      // loading: r => this.loading = r,
      params: {
        id: this.$route.params.more_id,
        offset: this.list.length,
        limit: this.limit
      }
    })
    this.title = data.title
    this.page_type = data.page_type
    let temp_list = data[`${data.page_type}s`]
    this.if_more = temp_list.length !== 0
    this.list = [...this.list, ...temp_list]
  }
}
